import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Each route's browser tab title (B-03): "People · EducAitor", and so on. */
const TITLES: [RegExp, string][] = [
  [/^\/$/, 'Overview'],
  [/^\/hub/, 'Leadership Hub'],
  [/^\/development/, 'Development'],
  [/^\/community/, 'Community'],
  [/^\/admin\/reflection-models/, 'Reflection models · Admin'],
  [/^\/shared\/.+/, 'Shared report'],
  [/^\/shared/, 'Shared with you'],
  [/^\/people/, 'People'],
  [/^\/frameworks/, 'Frameworks'],
  [/^\/school/, 'Organisation settings'],
  [/^\/account/, 'Your account'],
  [/^\/welcome/, 'Set up EducAitor'],
  [/^\/sign-in/, 'Sign in'],
  [/^\/sign-up/, 'Create an account'],
  [/^\/forgot-password/, 'Reset your password'],
  [/^\/join\//, 'Join your organisation'],
  [/^\/auth\/callback/, 'Signing in'],
  [/^\/admin\/schools\/.+/, 'Organisation · Admin'],
  [/^\/admin\/schools/, 'Organisations · Admin'],
  [/^\/admin\/frameworks\/.+\/organisations/, 'Framework organisations · Admin'],
  [/^\/admin\/frameworks\/.+/, 'Edit framework · Admin'],
  [/^\/admin\/frameworks/, 'Framework library · Admin'],
  [/^\/admin\/framework-requests/, 'Framework requests · Admin'],
  [/^\/admin\/health/, 'Platform health · Admin'],
];

export function RouteTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const match = TITLES.find(([re]) => re.test(pathname));
    document.title = `${match ? match[1] : 'Page not found'} · EducAitor`;
  }, [pathname]);
  return null;
}
